import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import stylesAutoLayout from '../AutoLayout.less';
import {WithValidation} from 'src/js/containers/auto_layout/components/validation';
import LayoutRenderer from 'src/js/lib/auto_layout/auto_layout_renderer';
import AutoLayoutService from 'src/js/lib/auto_layout/auto_layout_service';
import {ContentComponent} from 'src/js/model/auto_layout_content_schema';
import {LayoutComponent} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

class ComplexComponent extends React.PureComponent {
  render() {
    const {
      autoLayoutStateId,
      content,
      idSuffix,
      intl,
      layout,
      pathToData,
      screenId,
    } = this.props;
    const label = layout.getLabel()
      ? utils.TranslateUtils.translate({id: layout.getLabel()}, intl)
      : undefined;
    return (
      <div
        id={AutoLayoutService.getComponentId(screenId, pathToData, idSuffix)}
        className={stylesAutoLayout.dlSubComponent}
        title={label}
      >
        {layout.getLayoutItems().map((layoutItem) => {
          const newProps = LayoutRenderer.getProps(layoutItem, {
            ...this.props,
            key: layoutItem.getName(),
          });
          const ItemComponent = LayoutRenderer.getElement(layoutItem, true);
          const ItemChildren = LayoutRenderer.getChildren(layoutItem, newProps);

          // validation
          const property = layoutItem.getContentProperty();
          if (content.isValidated()) {
            const validators = content.getProperty(property).getValidators();
            if (validators && validators.length > 0) {
              return (
                <WithValidation
                  WrappedComponent={ItemComponent}
                  autoLayoutStateId={autoLayoutStateId}
                  screenId={screenId}
                  itemName={layoutItem.getName()}
                  wrappedChildren={ItemChildren}
                  {...newProps}
                />
              );
            }
          }

          return React.createElement(ItemComponent, newProps, ItemChildren);
        })}
      </div>
    );
  }
}

ComplexComponent.displayName = 'ComplexComponent';

ComplexComponent.propTypes = {
  autoLayoutStateId: PropTypes.string.isRequired,
  content: PropTypes.instanceOf(ContentComponent).isRequired,
  dataChanges: PropTypes.objectOf(PropTypes.any),
  dataSets: PropTypes.objectOf(PropTypes.any).isRequired,
  layout: PropTypes.instanceOf(LayoutComponent).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  isLast: PropTypes.bool,
  intl: intlShape.isRequired,
  rootData: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  readOnly: PropTypes.bool,
  textOnly: PropTypes.bool,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

ComplexComponent.defaultProps = {
  data: {},
  dataChanges: undefined,
  idSuffix: '',
  isLast: false,
  pathToData: '',
  readOnly: false,
  textOnly: false,
  expanded: false,
};

export default injectIntl(ComplexComponent);
